import { Suspense } from 'react';
import { LoadingSpinner } from '../components/ui/LoadingSpinner';

export function SuspenseWrap({ children }: { children: React.ReactNode }) {
  return <Suspense fallback={<LoadingSpinner message="Loading..." />}>{children}</Suspense>;
}
